// extracted by mini-css-extract-plugin
export var shopcampaign = "style-module--shopcampaign--tjR0y";
export var shopcampaign_title = "style-module--shopcampaign_title--N6O4Q";
export var shopcampaign_img = "style-module--shopcampaign_img--ocvhy";
export var shopcampaign_lead = "style-module--shopcampaign_lead--qjroo";
export var shopcampaign_description = "style-module--shopcampaign_description--nHb-r";
export var shopcampaign_image = "style-module--shopcampaign_image--NZN59";
export var shopcampaign_notice = "style-module--shopcampaign_notice--R10P5";
export var shopcampaign_buttons = "style-module--shopcampaign_buttons--d1KKh";
export var image = "style-module--image--6TQSW";
export var image_1 = "style-module--image_1--wg4MW";
export var buttons = "style-module--buttons--rflnv";
export var buttons_item = "style-module--buttons_item--OIk20";
export var button = "style-module--button--7jsHl";
export var button_icon = "style-module--button_icon--jT9rP";
export var button_text = "style-module--button_text--hakmo";